import * as Tabs from '@givebutter/primitives/tabs';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CampaignCoverEmbedVideoForm } from 'assets/js/pages/campaign-settings/campaign-details/CampaignCoverEmbedVideoForm';
import { CampaignCoverUploadPhotoForm } from 'assets/js/pages/campaign-settings/campaign-details/CampaignCoverUploadPhotoForm';
import * as SettingsCard from 'components/settings-card';
import * as Tooltip from 'components/tooltip';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';

const CampaignCoverPhotoDetails = () => {
    const { data: campaign } = useCurrentCampaign();
    const campaignVideoType = campaign?.cover?.type === 'video' ? 'video' : 'photo';

    return (
        <SettingsCard.Root>
            <SettingsCard.LeftSide>
                <SettingsCard.Heading>Cover photo</SettingsCard.Heading>
                <p className={'text-sm text-gray-700'}>Add a cover photo to your campaign.</p>
            </SettingsCard.LeftSide>
            <SettingsCard.RightSide>
                <Tabs.Root
                    defaultValue={campaign?.cover?.type === 'image' ? 'photo' : campaignVideoType}
                    className={'flex flex-col gap-4'}
                    variant={'underline'}
                >
                    <Tabs.List className={'w-fit text-sm'}>
                        <Tabs.Trigger value={'photo'} className="flex-none">
                            <div className={'flex items-center gap-2'}>
                                <p>Upload photo</p>
                                <Tooltip.Root>
                                    <Tooltip.Trigger asChild={true}>
                                        <FontAwesomeIcon size={'sm'} icon={faQuestionCircle} />
                                    </Tooltip.Trigger>
                                    <Tooltip.Portal>
                                        <Tooltip.Content inverse={true}>
                                            <p>
                                                Recommended dimensions: 1200 x 630px. Max Size: 1MB.
                                            </p>
                                            <Tooltip.Arrow inverse={true} />
                                        </Tooltip.Content>
                                    </Tooltip.Portal>
                                </Tooltip.Root>
                            </div>
                        </Tabs.Trigger>
                        <Tabs.Trigger value={'video'} className="flex-none">
                            Embed video
                        </Tabs.Trigger>
                    </Tabs.List>
                    <Tabs.Content value={'photo'}>
                        <CampaignCoverUploadPhotoForm />
                    </Tabs.Content>
                    <Tabs.Content value={'video'}>
                        <CampaignCoverEmbedVideoForm />
                    </Tabs.Content>
                </Tabs.Root>
            </SettingsCard.RightSide>
        </SettingsCard.Root>
    );
};

export { CampaignCoverPhotoDetails };
